<template>
  <div class="filter-widget">
    <button
      class="filter-header"
      :class="filterClass"
      :aria-label="filterLabel"
      @click.prevent="handleFilterState"
    >
      <span class="text">{{ title }}</span>
      <i
        class="icon-sm icon-reg"
        :class="iconClass"
        aria-hidden="true"
      />
    </button>
    <ais-refinement-list
      v-show="isExpanded"
      :attribute="attribute"
      :operator="operatorType"
      :show-more="showMore"
      :show-more-limit="showMoreLimit"
      :sort-by="sort"
      :transform-items="transformItems"
    />
  </div>
</template>

<script>
/* Components */
import { AisRefinementList } from 'vue-instantsearch/vue3/es';

export default {
  components: {
    AisRefinementList,
  },
  props: {
    attribute: {
      type: String,
      required: true,
    },
    operatorType: {
      type: String,
      required: false,
      default: 'or',
    },
    showMore: {
      type: Boolean,
      required: false,
      default: false,
    },
    showMoreLimit: {
      type: Number,
      required: false,
      default: 20,
    },
    sort: {
      type: Array,
      required: false,
      default() {
        return ['isRefined','count:desc','name:asc'];
      },
    },
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isExpanded: true,
    };
  },
  computed: {
    filterClass() {
      return this.isExpanded ? 'expanded' : 'collapsed';
    },
    filterLabel() {
      return this.isExpanded ? 'Collapse filter' : 'Expand filter';
    },
    iconClass() {
      return this.isExpanded ? 'icon-collapse' : 'icon-expand';
    },
  },
  methods: {
    handleFilterState() {
      this.isExpanded = !this.isExpanded;
    },
    transformItems(items) {
      if (this.attribute !== 'media_type') {
        return items;
      }

      return items.map(item => {
        let itemLabel = '';
        switch (item.label) {
        case 'pdf':
          itemLabel = 'PDF File';
          break;
        case 'video':
          itemLabel = 'Video';
          break;
        case 'blog':
        default:
          itemLabel = 'Blog';
        }

        return {
          ...item,
          label: itemLabel,
        };
      });
    },
  },
};
</script>
